import { Box } from '@mui/material'
import styles from './index.module.scss'

/**
 * Layout row for assistant text (left-aligned, right padding per spec).
 * @param {{ children: React.ReactNode, streaming?: boolean, messageId?: string, highlighted?: boolean }} props
 */
function AssistantMessageRow({
  children,
  streaming = false,
  messageId,
  highlighted = false,
}) {
  return (
    <Box
      component="div"
      data-message-id={messageId}
      className={`${styles.row}${streaming ? ` ${styles.rowStreaming}` : ''}${highlighted ? ` ${styles.rowFocused}` : ''}`}
    >
      <Box className={styles.content}>{children}</Box>
    </Box>
  )
}

export default AssistantMessageRow
